// 有多少import多少
import common from './module/common.js'
import login from './module/login'
import system from './module/system'
import home from './module/home'
import calendar from './module/calendar'
import dataBulletin from './module/dataBulletin'

export default {
    common,
    login,
    system,
    home,
    calendar,
    dataBulletin
}
